import { format, parseISO, getWeek } from 'date-fns';
import { sv } from 'date-fns/locale';

const isValidDate = d => d instanceof Date && !isNaN(d.getTime());

const toDateSafe = v => {
    if (v == null || v === '') { return null; }
    if (v instanceof Date) { return isValidDate(v) ? v : null; }
    if (typeof v === 'number') {
        const d = new Date(v);
        return isValidDate(d) ? d : null;
    }
    if (typeof v === 'string') {
        const ms = /\/Date\((\d+)\)\//.exec(v)?.[1];
        if (ms) { return new Date(Number(ms)); }
        try {
            const iso = parseISO(v);
            if (isValidDate(iso)) { return iso; }
        } catch { }
        const m = v.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
        if (m) {
            const [_, Y, M, D, h, min, s] = m;
            const d = new Date(+Y, +M - 1, +D, +h, +min, s ? +s : 0);
            return isValidDate(d) ? d : null;
        }
        const d = new Date(v);
        return isValidDate(d) ? d : null;
    }
    return null;
};

const toServer = (d, mode = 'iso') => {
    if (!isValidDate(d)) { return null; }
    if (mode === 'iso') { return d.toISOString(); }
    if (mode === 'ms') { return d.getTime(); }
    if (mode === 'dotnet') { return `/Date(${d.getTime()})/`; }
    return d; 
};

export default {
    install(app) {
        app.config.globalProperties.$formatDate = (date, fmt = 'yyyy-MM-dd') =>
            date ? format(new Date(date), fmt, { locale: sv }) : '';
        app.config.globalProperties.$parseDate = (s) => parseISO(s);
        app.config.globalProperties.$getWeekNumber = (date) =>
            getWeek(new Date(date), { locale: sv, weekStartsOn: 1 });

        app.config.globalProperties.$toDate = (v) => toDateSafe(v);
        app.config.globalProperties.$toServerDate = (d, mode = 'iso') => toServer(d, mode);
    }
};
